<template>
  <Dialog
    v-model:visible="showLoading"
    modal
    :block-scroll="true"
    :closable="false"
    :close-on-escape="false"
    :draggable="false"
    :maximizable="false"
    :show-header="false"
    :show-footer="false"
    content-class="p-0!"
    :pt:mask="'!bg-white/60'"
    class="rounded-3xl! border-0! bg-transparent! shadow-none!"
  >
    <div class="flex flex-col items-center justify-center p-8">
      <ProgressSpinner class="h-10! w-10!" stroke-width="5" />
      <span class="text-color-primary mt-4 text-center text-2xl">{{
        loadingMessage ?? 'Loading...'
      }}</span>
    </div>
  </Dialog>
</template>

<script lang="ts" setup>
import useAppStore from '~/stores/app';

const { showLoading, loadingMessage } = storeToRefs(useAppStore());
</script>
